import { useEffect } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { CallDetailsStatus } from 'features/call/call-details/enums';
import { setCallDetailsCalleeStatus } from 'features/call/call-details/store';
import { useWhileComponentMounted } from 'features/utils/hook';
import { VoiceMeetingEventBus } from 'features/voice-meeting/services';

export const useCallDetailsParticipantHandler = () => {
  const whileComponentMounted = useWhileComponentMounted();
  const dispatch = useAppDispatch();

  const attendeePresenceDeclinedHandler = () => {
    dispatch(
      setCallDetailsCalleeStatus({
        isDeafParticipant: false,
        status: CallDetailsStatus.CALLEE_RECONNECT,
      })
    );
  };

  useEffect(() => {
    VoiceMeetingEventBus.hearingCallDeclined$
      .pipe(whileComponentMounted())
      .subscribe(attendeePresenceDeclinedHandler);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
